import React from 'react'
import styled from 'styled-components'
function About() {
    return (
        <Wrapper id="about">

            <Heading>
                <h2>About</h2>
                <h1>
                Personal Info
                </h1>
                <p>Get to know a little about me</p>
                <hr/>
            </Heading>
               
            <InfoContainer>
                <Info>
                    
                    <h2>Hello!</h2>
                    <p>My name is Shashwat and I'm a passionate Frontend Web Developer using web technologies to build amazing products and focusing on solving problems for different niches and different industries using the power of technology.</p>

<p>I would love to hear from you. Whether it's a project, job opportunity, or just a chat. Feel free to contact me.</p>
                </Info>

                <Skill>
                    <h2>Skills</h2>
                    <Buttons>
                        <div>

                        <button>HTML</button>
                        <button>CSS</button>
                        <button>JAVASCRIPT</button>
                        <button>TAILWIND CSS</button>
                        <div>
                        <button>NEXTJS</button>
                        <button>REACTJS</button>
                        <button>NODEJS</button>
                        <button>REDUX</button>

                        <button>GIT</button>
                        <button>FIREBASE</button>
                        
                        </div>
                        
                        </div>
                        
                    </Buttons>
                </Skill>

            </InfoContainer>
           
            

        


        </Wrapper>
    )
}

export default About

const Wrapper=styled.div`
margin-top:10%;
height:100vh;
`;

const Heading=styled.div`
text-align:center;

h1{
    font-size:40px;
    letter-spacing:5px;
    word-spacing:2px;
}
h2{
    font-size:24px;
    letter-spacing:2px;
}
p{
    word-spacing:2px;
    letter-spacing:2px;
}
hr{
    width:15%;
    border:0.5px solid lightgrey;
}
@media screen and (max-width:768px){
    h1{
        font-size:30px;

    }
    h2{
        font-size:20px;

    }
    p{
        font-size:14px;
    }
}
`;

const InfoContainer=styled.div`
margin-top:5%;
margin-left:5%;
margin-right:5%;
display:grid;
// justify-content:center;
grid-template-columns:50% auto;
@media screen and (max-width:768px){
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
}
`;
const Info=styled.div`
padding-left:14px;
/* padding-right:14px; */
p{
    color:grey;
    line-height:1.5em;
    letter-spacing:2px;
    padding-top:10px;   
}
@media screen and (max-width:768px){
h2{
    font-size:20px;
}
p{
    font-size:14px
}
}
`;
const Skill=styled.div`
padding-left:14px;
padding-right:14px;

h2{
margin-left:15px;

}
@media screen and (max-width:768px){
    h2{margin-left:0;}
}
`;
const Buttons=styled.div`
margin-top:30px;

div{
    margin-top:10px;
}
button{
    
    margin-left:15px;
    border-radius:5px;
    border:none;
    margin-top:10px;
    letter-spacing:1px;
    font-weight:600;
    font-size:10px;
    overflow:hidden;
    padding:12px;
}
@media screen and (max-width:768px){
    div:nth-child(1){

        /* display:fle; */
        margin-top:0;

        /* flex-direction:row; */
        /* flex-wrap:wrap; */
        /* justify-content:flex-start; */
    }
    
     button{
         margin-left:0;
         /* margin-right:100px; */
         /* margin-top:0; */
        margin-right:7px;
        
        /* width:90px; */
        padding:10px;

    } 
}
`;
